<template>
    <div>
        <WebsiteHeader />
        <NuxtPage />
    </div>
</template>